import PropTypes from 'prop-types';
import React from 'react';
import EventsPicker from '../../components/rates/eventsPicker';
import { Form } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';

export default function RateFormSettingsEvents({ organizationId, event = null, form, onChangeForm, onChangeFormObject, formErrors, rate, onChangeEvents, selectedEvents, events }) {
    const { t } = useTranslation();
    const formatLabel = React.useCallback((event, t) => {
        return (
            event.name +
            ' - ' +
            new Date(event.start_date).toLocaleDateString([], { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: event.timezone }) +
            ' - ' +
            event.id +
            ' - ' +
            t('ticket.rate_template.' + event.publication_status)
        );
    }, []);

    return (
        <>
            <Form.Field>
                <label>{t('ticket.rates.settingsEventsLabel')}</label>
            </Form.Field>
            <EventsPicker onSave={onChangeEvents} events={events} selected={selectedEvents} organizationId={organizationId} formatLabel={formatLabel} rate={rate} />
        </>
    );
}

RateFormSettingsEvents.propTypes = {
    organizationId: PropTypes.number.isRequired,
    event: PropTypes.object,
    form: PropTypes.object.isRequired,
    rate: PropTypes.object.isRequired,
    onChangeForm: PropTypes.func.isRequired,
    onChangeFormObject: PropTypes.func.isRequired,
    formErrors: PropTypes.object.isRequired,
    onChangeEvents: PropTypes.func.isRequired,
    selectedEvents: PropTypes.array.isRequired,
    events: PropTypes.array.isRequired
};
